import React, { useEffect } from "react";
import { Button, Fab, TableBody, TableCell, TableRow, Typography, Grid } from '@mui/material';
import { FindInPage } from "@mui/icons-material";
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

const columns = [
    { id: 'rating', label: 'Rating' },
    { id: 'company_name', label: 'Company Name' },
    { id: 'mc', label: 'MC #' },
    { id: 'dot', label: 'DOT #' },
    { id: 'city', label: 'City' },
    { id: 'state', label: 'State' },
];

function SearchResultsTableMobile({ toggleDrawer, dataFiltered, pageParent, rowsPerPageParent }) {
    const [page, setPage] = React.useState(pageParent);
    const [rowsPerPage, setRowsPerPage] = React.useState(rowsPerPageParent);
    const [dataValue, setDataValue] = React.useState(dataFiltered);

    useEffect(() => {
        setDataValue(dataFiltered);
    }, [dataFiltered]);

    useEffect(() => {
        setPage(pageParent);
        setRowsPerPage(rowsPerPageParent)
    }, [pageParent, rowsPerPageParent]);


    const handleData = (data) => {
        toggleDrawer(true, data);
    }

    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip placement="right" {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 220,
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9',
        },
    }));


    return (
        <>
            <TableBody style={{ background: '#f3f6f8' }}>
                {dataValue?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((data) => {
                        {
                            return (
                                <>
                                    <Grid container onClick={() => handleData(data)} marginTop={'1rem'} width={'100vw'} style={{ background: 'white' }}>
                                        <Grid item xs={3} textAlign={'center'} margin={'auto'}>
                                            {(data.rating === 'N') &&
                                                <HtmlTooltip
                                                    title={
                                                        <React.Fragment>
                                                            <Typography style={{ color: '#FF0000', fontWeight: 'bold' }}>No Buy Rating</Typography>
                                                        </React.Fragment>
                                                    }
                                                >

                                                    <Button style={{ background: '#FF0000', color: 'white', height: '64px', borderRadius: '50%' }}>
                                                        {data.rating}
                                                    </Button></HtmlTooltip>
                                            }
                                            {(data.rating === 'B') &&
                                                <HtmlTooltip
                                                    title={
                                                        <React.Fragment>
                                                            <Typography style={{ color: '#58A618', fontWeight: 'bold' }}>Buy Rating</Typography>
                                                        </React.Fragment>
                                                    }
                                                >
                                                    <Button style={{ background: '#58A618', color: 'white', height: '64px', borderRadius: '50%' }}>
                                                        {data.rating}
                                                    </Button></HtmlTooltip>
                                            }
                                            {(data.rating === 'C') &&
                                                <HtmlTooltip
                                                    title={
                                                        <React.Fragment>
                                                            <Typography style={{ color: '#FFAB00', fontWeight: 'bold' }}>Contact Us</Typography>
                                                            {"@1-972-755-1924 for more information."}
                                                        </React.Fragment>
                                                    }
                                                >
                                                    <Button style={{ background: '#FFAB00', color: 'white', height: '64px', borderRadius: '50%' }}>
                                                        {data.rating}
                                                    </Button>
                                                </HtmlTooltip>
                                            }
                                        </Grid>
                                        <Grid item xs={9} padding={'1rem'}>
                                            <Grid container marginTop={'1rem'} margin={'auto'}>
                                                <Typography fontSize={'18px'} color={'#616365'}>
                                                    {data.company_name}
                                                </Typography>
                                            </Grid>
                                            <Grid container marginTop={'0.5rem'} fontSize={'14px'}>
                                                <Grid item xs={6} color={'#616365'}>
                                                    MC #
                                                </Grid>
                                                <Grid item xs={6} textAlign={'right'}>
                                                    {data.mc}
                                                </Grid>
                                            </Grid>
                                            <Grid container marginTop={'0.5rem'} fontSize={'14px'}>
                                                <Grid item xs={6} color={'#616365'}>
                                                    DOT #
                                                </Grid>
                                                <Grid item xs={6} textAlign={'right'}>
                                                    {data.dot}
                                                </Grid>
                                            </Grid>
                                            {/* <Grid container marginTop={'0.5rem'} fontSize={'14px'}>
                                                <Grid item xs={6} color={'#616365'}>
                                                    City
                                                </Grid>
                                                <Grid item xs={6} textAlign={'right'}>
                                                    {data.city}
                                                </Grid>
                                            </Grid>
                                            <Grid container marginTop={'0.5rem'} fontSize={'14px'}>
                                                <Grid item xs={6} margin={'auto'} color={'#616365'}>
                                                    State
                                                </Grid>
                                                <Grid item xs={6} textAlign={'right'}>
                                                    {data.state}
                                                </Grid>
                                            </Grid> */}
                                            <Grid item xs={6} margin={'auto'} color={'#616365'}>
                                            </Grid>

                                        </Grid>

                                    </Grid>
                                </>
                            );
                        };
                    })}
            </TableBody>
        </>
    )
}

export default SearchResultsTableMobile;